import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FETCH_DRIVERPROF_ACTION,
  FETCH_DRIVERPROF_SUCCESS_ACTION,
  FETCH_DRIVERPROF_FAIL_ACTION,
  DELETE_USER_INIT_ACTION,
  DELETE_USER_SUCCESS_ACTION,
  DELETE_USER_FAIL_ACTION,
  FETCH_DRIVERBYID_ACTION,
  FETCH_DRIVERBYID_FAIL_ACTION,
  FETCH_DRIVERBYID_SUCCESS_ACTION,
  FETCH_OPENDRIVER_ACTION,
  FETCH_OPENDRIVER_FAIL_ACTION,
  FETCH_OPENDRIVER_SUCCESS_ACTION,
  ATTACH_DRIVER_ACTION,
  ATTACH_DRIVER_FAIL_ACTION,
  ATTACH_DRIVER_SUCCESS_ACTION,
  UPDATE_USERPROF_ACTION,
  UPDATE_USERPROF_FAIL_ACTION,
  UPDATE_USERPROF_SUCCESS_ACTION,
  DETTACH_DRIVER_ACTION,
  DETTACH_DRIVER_FAIL_ACTION,
  DETTACH_DRIVER_SUCCESS_ACTION,
} from "./action";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;



export function* DriverActionWatcher() {
  
}
